module.exports = __webpack_public_path__ + "files/cb754192022d864259d2973c82f9e57f.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/windows_dark.png
// module id = 937
// module chunks = 76